import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from "../index";
import './Tabs.scss';


const Tabs = (props) => {
  const { children, defaultTab, loadingData, onClickAction, rightElement,extraContent } = props;
  const [selectedTab, setSelectedTab] = useState(defaultTab);

  const selectTab = (idx) => {
    if (idx + 1 !== selectedTab) {
      setSelectedTab(idx + 1);
      onClickAction(idx + 1);
    }
  };

  return (
    <div className="tabs-container">
      <div className="nav-container">
        <ul className="nav">
          {children.map(
            (elem, idx) =>
              elem && (
                <TabTitle
                  title={elem.props.title}
                  active={selectedTab === idx + 1}
                  disabled={elem.props.disabled}
                  selectTab={() => selectTab(idx)}
                  key={`tab-title-${idx}`}
                />
              )
          )}
        </ul>
        {rightElement && rightElement}
      </div>
      {extraContent}
      {loadingData ? <Spinner /> : children[selectedTab - 1]}
    </div>
  );
};

export default Tabs;

Tabs.propTypes = {
  defaultTab: PropTypes.number,
  loadingData: PropTypes.bool,
};

Tabs.defaultProps = {
  defaultTab: 1,
  loadingData: false,
};

const TabTitle = ({title, selectTab, active, disabled}) => (
  <li className={`nav-item ${active ? 'active' : ''}`}>
    <button
      className={`nav-link btn-link ${active ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
      onClick={selectTab}
      disabled={disabled}
    >
      {title}
    </button>
  </li>
);

TabTitle.propTypes = {
  title: PropTypes.string,
  selectTab: PropTypes.func.isRequired,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
};

TabTitle.defaultProps = {
  active: false,
  disabled: false,
};

export const Tab = ({ children, className }) => (
  <div className={className}>{children}</div>
);

Tab.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Tab.defaultProps = {
  className: '',
  children: null,
};
